import { RoutePage } from "@/components/RoutePage";
import { PlatformSection } from "@/components/sections/PlatformSection";

export default function PlatformPage({ onOpenContact }) {
  return (
    <RoutePage
      kicker="The Platform"
      badge="P"
      accent="#38BDF8"
      title="Map. Model. Guide. One closed loop."
      intro="The Neurobolt platform is engineered as a single, continuous capture–model–feedback cycle — built so neural activity, AI interpretation, and adaptive biofeedback evolve together rather than in isolation."
      primaryCta="Request technical brief"
      secondaryCta={{ href: "/technology", label: "Explore the technology" }}
      onOpenContact={onOpenContact}
      next={{ href: "/technology", label: "Technology" }}
      meta={{
        title: "Platform",
        description:
          "Neurobolt.AI's closed-loop platform — biocompatible interface, neural mapping, physics-aware AI, and adaptive biofeedback as one continuous system.",
        path: "/platform",
      }}
      stats={[
        { k: "5", v: "Stage pipeline" },
        { k: "4", v: "Core principles" },
        { k: "1", v: "Continuous loop" },
        { k: "∞", v: "Compounding data" },
      ]}
    >
      <PlatformSection />
    </RoutePage>
  );
}
